import {
  Container,
  Dropdown,
  Menu,
} from 'semantic-ui-react';

import React, {
  Component,
} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { push, replace } from 'react-router-redux';
import moment from 'moment-timezone';
import NavBar from '../../components/NavBar';
import BookingsList from '../../components/UpdatedComponents/UCBookingsList';
import { TRANSLATION_FILES } from '../../constants/translation';
import { showsBulkEditCustomFields } from '../../utils/vietnam';
import { routes } from './navigations';

moment.locale('en-gb');

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isAdmin: PropTypes.bool,
      isDeveloperSupervisor: PropTypes.bool,
      isDeveloperSalesManager: PropTypes.bool,
      isDeveloperSalesAdmin: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        himsIsEnabled: PropTypes.bool,
      }),
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = () => {
    const loading = true;
    const menuIsTab = window.innerWidth <= 590;
    return {
      loading,
      menuIsTab,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState();
    this.state = {
      ...state,
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  hasAccess(check = false) {
    if (
      this.props.auth.isBranchLeader ||
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  handleOnLoading = (loading) => {
    this.setState({ loading });
  }
  himsIsEnabled = () => {
    const { appConfig } = this.props;
    return appConfig && appConfig.data && appConfig.data.himsIsEnabled;
  }
  canBulkEditCustomField = () => {
    const { auth } = this.props;
    return showsBulkEditCustomFields(auth) && (
      auth.isHeadquarters ||
      auth.isAdmin ||
      auth.isDeveloperSupervisor ||
      auth.isDeveloperSalesManager ||
      auth.isDeveloperSalesAdmin
    );
  }
  handleManageClick = (e, data) => {
    e.preventDefault();
    const { store } = this.context;
    store.dispatch(push(`/bookings/${data.value}`));
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    store.dispatch(replace(value));
  }
  handleResize = () => {
    const state = {};
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    this.setState({ ...state });
  }
  render() {
    const { t, auth, location } = this.props;
    const { pathname } = location;
    const links = routes(auth.company.countryCode).map(l => ({
      ...l,
      text: t(l.text),
    }));
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                content={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          rightNav={this.hasAccess() || this.canBulkEditCustomField() ? (
            <Dropdown item text={t('Manage')}>
              <Dropdown.Menu>
                {this.hasAccess() && <Dropdown.Item onClick={this.handleManageClick} value="manage/">{t('Manage Pending Status')}</Dropdown.Item>}
                {this.hasAccess() && this.himsIsEnabled() && <Dropdown.Item onClick={this.handleManageClick} value="hims/">HIMS Booking Sync</Dropdown.Item>}
                {this.canBulkEditCustomField() && <Dropdown.Item onClick={this.handleManageClick} value="customEdit/">{t('Bulk Edit Custom Fields')}</Dropdown.Item>}
              </Dropdown.Menu>
            </Dropdown>
            ) : null
          }
        />
        <BookingsList
          onLoading={this.handleOnLoading}
        />
      </Container>
    );
  }
}
export default withTranslation(TRANSLATION_FILES.screens)(connect(List.mapStateToProps)(List));



// WEBPACK FOOTER //
// ./src/containers/Bookings/List.jsx